import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  AgentCallSummaryResponse,
  CallMetricsResponse,
  MetricsPeriodFilter
} from '../models/call-metrics.model';

@Injectable({ providedIn: 'root' })
export class CallMetricsApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}api/call-metrics`;

  getDashboard(period: MetricsPeriodFilter = {}): Observable<CallMetricsResponse> {
    return this.http.get<CallMetricsResponse>(`${this.base}/dashboard`, { params: this.toParams(period) });
  }

  /**
   * Lista las métricas por agente. El swagger marca el response como
   * `AgentCallSummaryResponse` (sin `[]`), pero la práctica devuelve un array —
   * el componente valida con `Array.isArray` antes de usar.
   */
  listAgentMetrics(): Observable<AgentCallSummaryResponse[]> {
    return this.http.get<AgentCallSummaryResponse[]>(`${this.base}/agents`);
  }

  getAgentMetrics(agentId: number, period: MetricsPeriodFilter = {}): Observable<CallMetricsResponse> {
    return this.http.get<CallMetricsResponse>(`${this.base}/agents/${agentId}`, { params: this.toParams(period) });
  }

  exportMetrics(period: MetricsPeriodFilter = {}, format = 'csv'): Observable<Blob> {
    const params = this.toParams(period).set('format', format);
    return this.http.get(`${this.base}/export`, { params, responseType: 'blob' });
  }

  private toParams(period: MetricsPeriodFilter): HttpParams {
    let params = new HttpParams();
    if (period.periodStart) params = params.set('periodStart', period.periodStart);
    if (period.periodEnd) params = params.set('periodEnd', period.periodEnd);
    return params;
  }
}
